import styled from 'styled-components'

export const ContainerButton = styled.div`
  margin-bottom: 25px;
  display: flex;
  justify-content: flex-end;
`
